'use client';
import { Children } from 'react';
import { createPortal } from 'react-dom';
import './environment/index.mjs';
import { useIsServer } from './use-is-server.mjs';
import { useEnvironmentContext } from './environment/environment-context.mjs';

const Portal = (props) => {
  const { children, container, disabled } = props;
  const isServer = useIsServer();
  const getRootNode = useEnvironmentContext();
  if (isServer || disabled)
    return children;
  const doc = getRootNode?.().ownerDocument ?? document;
  const mountNode = container?.current ?? doc.body;
  return Children.map(children, (child) => createPortal(child, mountNode));
};

export { Portal };
